import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
class CookiesModule extends VuexModule {
  confirmed = false;

  @Mutation
  setConfirmed(confirmed: boolean) {
    this.confirmed = confirmed;
  }
}

export default CookiesModule;
